// extracted by mini-css-extract-plugin
export var borderRadius = "_dz-4";
export var large = "_dz-3";
export var logoContainer = "_dz-0";
export var nameLogo = "_dz-2";
export var small = "_dz-1";